
import './App.css';
import { Ticatactoe } from './component/ticatactoe';

function App(){
  return <>
  <Ticatactoe />
  </>
}

export default App;
